module.exports = __webpack_public_path__ + "static/media/humidicula-llanero.332a3698.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/humidicula-llanero.jpg
// module id = 93
// module chunks = 0